export default {
  computed: {
    imageAttachmentId() {
      return this.card?.featuredImageId || '';
    },
    imageAttachment() {
      return this.$store.getters['attachments/get'][this.imageAttachmentId] || {};
    },
    thumbnailUrl() {
      if (this.imageAttachment.url) {
        return this.imageAttachment.url;
      }
      if (this.asset) {
        const attachment = this.$store.getters['attachments/get'][this.asset.displayAttachmentId];
        return attachment?.smallThumbnail;
      }
    },
  },
};
